<template>
  <button class="filter-button" :class="buttonModifier" @click="toggleFilter">{{ name }}</button>
</template>

<script src="./filter-button.js"></script>
<style src="./filter-button.scss" lang="scss"></style>
